export const wizard = {
  en: {
    title: "Request Assistant",
    subtitle: "Answer the questions step by step",
    aiAssistant: "AI Assistant",
    noQuestions: "No questions available",
    back: "Back",
    unsavedChanges: "You have unsaved changes. Are you sure you want to leave?",
    minimumCompletion: "Please complete at least 75% of the questions",
    submitSuccess: "Request submitted successfully",
    submitError: "Failed to submit request",
    loadError: "Error loading questionnaire",
    progress: {
      step: "Step {current} of {total}",
      title: "Progress",
      confirmed: "confirmed",
      ready: "Ready to submit",
      moreNeeded: "{percent}% more to submit",
    },
    question: {
      required: "Required",
      confirmed: "Confirmed",
    },
    input: {
      fixText: "Fix text",
      placeholder: "Type your answer...",
      selectOption: "Select an option",
      multipleOptions: "Multiple options",
      yes: "Yes",
      low: "Low",
      high: "High",
      enterNumber: "Enter a number",
      fileUploadSoon: "File upload coming soon...",
      unsupportedType: "Unsupported question type",
    },
    actions: {
      confirmNext: "Confirm & Next",
      confirm: "Confirm",
      next: "Next",
      submitting: "Submitting...",
      submitRequest: "Submit Request",
      previous: "Previous",
      back: "Prev.",
      skip: "Skip",
      confirmSubmission: "Confirm Submission",
      confirmSubmissionDesc: "You have completed {percent}% of the questionnaire. Are you sure you want to submit your request?",
      cancel: "Cancel",
      submit: "Submit",
    },
    aiAssistantPanel: {
      title: "AI Assistant",
      subtitle: "Help and examples for this question (does not fill the form)",
      suggestion: "Suggestion",
      loadingSuggestion: "Loading suggestion...",
      examples: "Examples:",
      noSuggestion: "No suggestion available for this question.",
      askTitle: "Ask the assistant",
      placeholder: "Type your question...",
    },
    serviceTypes: {
      ariaLabel: "Service types",
      weeks: "weeks",
      ongoing: "Ongoing",
    },
  },
  es: {
    title: "Asistente de Solicitud",
    subtitle: "Responde las preguntas paso a paso",
    aiAssistant: "Asistente AI",
    noQuestions: "No hay preguntas disponibles",
    back: "Volver",
    unsavedChanges: "Tienes cambios sin guardar. ¿Estás seguro de que deseas salir?",
    minimumCompletion: "Por favor completa al menos el 75% de las preguntas",
    submitSuccess: "Solicitud enviada exitosamente",
    submitError: "Error al enviar la solicitud",
    loadError: "Error al cargar el cuestionario",
    progress: {
      step: "Paso {current} de {total}",
      title: "Progreso",
      confirmed: "confirmadas",
      ready: "Listo para enviar",
      moreNeeded: "{percent}% más para enviar",
    },
    question: {
      required: "Requerido",
      confirmed: "Confirmado",
    },
    input: {
      fixText: "Corregir texto",
      placeholder: "Escribe tu respuesta...",
      selectOption: "Selecciona una opción",
      multipleOptions: "Opciones múltiples",
      yes: "Sí",
      low: "Bajo",
      high: "Alto",
      enterNumber: "Ingresa un número",
      fileUploadSoon: "Subida de archivos próximamente...",
      unsupportedType: "Tipo de pregunta no soportado",
    },
    actions: {
      confirmNext: "Confirmar y Siguiente",
      confirm: "Confirmar",
      next: "Siguiente",
      submitting: "Enviando...",
      submitRequest: "Enviar Solicitud",
      previous: "Anterior",
      back: "Ant.",
      skip: "Omitir",
      confirmSubmission: "Confirmar Envío",
      confirmSubmissionDesc: "Has completado el {percent}% del cuestionario. ¿Estás seguro de que deseas enviar tu solicitud?",
      cancel: "Cancelar",
      submit: "Enviar",
    },
    aiAssistantPanel: {
      title: "Asistente AI",
      subtitle: "Ayuda y ejemplos para esta pregunta (no rellena el formulario)",
      suggestion: "Sugerencia",
      loadingSuggestion: "Cargando sugerencia...",
      examples: "Ejemplos:",
      noSuggestion: "No hay sugerencia disponible para esta pregunta.",
      askTitle: "Preguntar al asistente",
      placeholder: "Escribe tu pregunta...",
    },
    serviceTypes: {
      ariaLabel: "Tipos de servicio",
      weeks: "semanas",
      ongoing: "Continuo",
    },
  },
};
